import type { FeedPost } from '../domain/models'

export const seedFeedPosts: readonly FeedPost[] = [
  {
    id: 'sample-main-alextrextra-01',
    showId: 'show-01',
    channel: 'main',
    authorId: 'fan-alextrextra',
    authorName: '@Alextrextra',
    body: 'Who is getting there early for the first set?',
    createdAt: '2027-10-14T16:23:00-05:00',
    source: 'sample',
  },
  {
    id: 'sample-main-reply-riffmara-01',
    showId: 'show-01',
    channel: 'main',
    authorId: 'fan-riffmara',
    authorName: '@RiffMara',
    body: 'I am — aiming for doors. I’ll be in the red patch jacket.',
    createdAt: '2027-10-14T16:24:00-05:00',
    parentId: 'sample-main-alextrextra-01',
    source: 'sample',
  },
  {
    id: 'seed-main-01',
    showId: 'show-01',
    channel: 'main',
    authorId: 'crew',
    authorName: 'TOUR DESK',
    body: 'Dallas roll call. Save your arrival plan and keep the main board close.',
    createdAt: '2027-10-14T16:00:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-main-band-hello-01',
    showId: 'show-01',
    channel: 'main',
    authorId: 'the-paradox',
    authorName: 'THE PARADOX',
    body: 'What’s up, Dallas? Say hello, meet somebody headed to the show, and drop your look in Fits.',
    createdAt: '2027-10-14T16:05:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-fits-01',
    showId: 'show-01',
    channel: 'fits',
    authorId: 'the-paradox',
    authorName: 'THE PARADOX',
    body: 'Fit check before doors. We pulled up together—show us what you’re wearing tonight.',
    createdAt: '2027-10-14T17:22:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-merch-01',
    showId: 'show-01',
    channel: 'merch',
    authorId: 'crew',
    authorName: 'MERCH DESK',
    body: 'Shop the current collection below. City drops will appear when announced.',
    createdAt: '2027-10-14T17:35:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-scene-01',
    showId: 'show-01',
    channel: 'scene',
    authorId: 'crew',
    authorName: 'TOUR DESK',
    body: 'Dallas, bring the noise.',
    createdAt: '2027-10-14T17:48:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-main-02',
    showId: 'show-02',
    channel: 'main',
    authorId: 'crew',
    authorName: 'TOUR DESK',
    body: 'Austin is next on the route. Start a plan and save the stop.',
    createdAt: '2027-10-15T10:00:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-fits-02',
    showId: 'show-07',
    channel: 'fits',
    authorId: 'fan-static',
    authorName: '@StaticHeart',
    body: 'Trading jacket patch ideas before Los Angeles. What is going on the back panel?',
    createdAt: '2027-10-15T12:00:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-merch-02',
    showId: 'show-05',
    channel: 'merch',
    authorId: 'fan-loud',
    authorName: '@LouderThanLake',
    body: 'Saving Chicago and checking the merch before the show.',
    createdAt: '2027-10-15T13:00:00-05:00',
    source: 'seed',
  },
  {
    id: 'seed-scene-02',
    showId: 'show-06',
    channel: 'scene',
    authorId: 'fan-highline',
    authorName: '@HighlineSignal',
    body: 'Denver crew: add your arrival plan before you hit the road.',
    createdAt: '2027-10-15T14:00:00-05:00',
    source: 'seed',
  },
] as const
